export default {
    hasError: state => key => {
        return state.validationErrors[key] !== undefined;
    },

    hasMultilingualError: (state, getters) => key => {
        return getters.hasError(key.replaceAll('[','.').replaceAll(']',''));
    }
};